<div *ngFor="let block of blocks; let index = index; let first = first; let last = last;"
    [ngSwitch]="block.type"
    [ngClass]="block.blockClasses"
    [class.background-image]="block.background"
    [class.first-block]="first"
    [class.last-block]="last"
    class="block block-{{index}} {{block.type | kebabCase}}"
    (finderIntersection)="checkForIntersection($event)"
    [threshold]="block.parallaxTransitions?.threshold"
    [rootMargin]="block.parallaxTransitions?.rootMargin"
    [intersectionEnabled]="block.parallaxTransitions"
    [attr.data-scroll-up]="block.parallaxTransitions?.scrollUp"
    [attr.data-scroll-down]="block.parallaxTransitions?.scrollDown"
    [attr.data-scroll]="block.parallaxTransitions?.scroll"
    [finderPartialBg]="block.partialBg === 'true'"
    [finderOverlayElement]="block.overlay"
    [finderBgImage]="block"
    [isMobile]="isMobile"
>
    <!-- Animations -->
    <ng-container *ngIf="block.animations">
        <ng-container *ngFor="let animation of block.animations">
            <ng-container *ngIf="animation && (animation.location === '0' || !animation.location)">
                <finder-animation [data]="animation" [ngClass]="animation.name"></finder-animation>
            </ng-container>
        </ng-container>
    </ng-container>
    <!-- Top HR -->
    <finder-horizontal-rule *ngIf="block.hrData?.topLine"
        [finderCmsMargin]="block.spacing"
        [data]="block.hrData"
        [position]="'top'"
    ></finder-horizontal-rule>
    <!-- Image Block -->
    <finder-block-wrapper *ngSwitchCase="'imageBlock'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        class="block-element image-block-container">
        <finder-image-block
            [blockData]="block"
        ></finder-image-block>
    </finder-block-wrapper>
    <!-- Map -->
    <finder-block-wrapper *ngSwitchCase="'map'"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        class="block-element hide-on-mobile" id="campaign-map">
        <finder-campaign-map
            [mapData]="block"
        ></finder-campaign-map>
    </finder-block-wrapper>
    <!-- Product Group -->
    <finder-block-wrapper *ngSwitchCase="'productsGroup'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        class="block-element">
        <finder-products-group
            [productsData]="block"
        ></finder-products-group>
    </finder-block-wrapper>
    <!-- CTA -->
    <finder-block-wrapper *ngSwitchCase="'cta'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        class="block-element">
        <finder-campaign-cta
            [ctaData]="block"
        ></finder-campaign-cta>
    </finder-block-wrapper>
    <!-- Banner -->
    <finder-block-wrapper *ngSwitchCase="'promoBanner'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="[block.fullWidth === false ? 'inner-container' : '', '' + block.style]"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.no-padding]="!disableDefaultSpacing"
        class="block-element">
        <finder-promo-banner
            [promoData]="block"
        ></finder-promo-banner>
    </finder-block-wrapper>
    <!-- App Overview -->
    <finder-block-wrapper *ngSwitchCase="'appOverview'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        class="block-element">
        <finder-app-overview
            [appData]="block"
        ></finder-app-overview>
    </finder-block-wrapper>
    <!-- Timeline Image -->
    <finder-block-wrapper *ngSwitchCase="'timelineImage'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.no-padding]="!disableDefaultSpacing"
        class="block-element">
        <finder-timeline-image
            [timelineData]="block"
        ></finder-timeline-image>
    </finder-block-wrapper>
    <!-- Parallax Background -->
    <finder-block-wrapper *ngSwitchCase="'parallaxBg'"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        [class.no-padding]="!disableDefaultSpacing"
        class="block-element">
        <finder-parallax-background
            [data]="block"
            [theme]="theme.finder"
        ></finder-parallax-background>
    </finder-block-wrapper>
    <!-- Drawer -->
    <finder-block-wrapper *ngSwitchCase="'drawer'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        class="block-element">
        <finder-campaign-drawer-group
            [groupData]="block.data"
        ></finder-campaign-drawer-group>
    </finder-block-wrapper>
     <!-- Polyline -->
    <finder-polyline *ngIf="block.polyline || block.mobilePolyline "
        [polyline]="block.polyline"
        [mobilePolyline]="block.mobilePolyline">
    </finder-polyline>
    <!-- Generic Text -->
    <finder-block-wrapper *ngSwitchCase="'genericText'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        class="block-element">
        <finder-generic-text
            [data]="block"
        ></finder-generic-text>
    </finder-block-wrapper>
    <!-- Generic Text With Button-->
    <finder-block-wrapper *ngSwitchCase="'genericTextCta'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        class="block-element">
        <finder-generic-text-cta
            [data]="block"
        ></finder-generic-text-cta>
    </finder-block-wrapper>
    <!-- Drawer Infographic -->
    <finder-block-wrapper *ngSwitchCase="'drawerInfographic'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="['blockId-' + block.data.blockId, '' + block.style]"
        [class.sm-margin]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        class="block-element">
        <finder-campaign-drawer-infographic
            [groupData]="block.data"
        ></finder-campaign-drawer-infographic>
    </finder-block-wrapper>
    <!-- Drawer Infographic Multirow -->
    <finder-block-wrapper *ngSwitchCase="'drawerGroupMultiRow'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="['blockId-' + block.data.blockId, block.style]"
        [class.sm-margin]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        class="block-element">
        <finder-campaign-drawer-group-multi-row
            [groupData]="block.data"
        ></finder-campaign-drawer-group-multi-row>
    </finder-block-wrapper>
    <!-- Drawer Link Group -->
    <finder-block-wrapper *ngSwitchCase="'drawerLink'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        class="block-element">
        <finder-campaign-drawer-link-group
            [groupData]="block"
        ></finder-campaign-drawer-link-group>
    </finder-block-wrapper>
    <!-- List Block -->
    <finder-block-wrapper *ngSwitchCase="'listBlock'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        class="block-element">
        <finder-list-block
            [data]="block"
        ></finder-list-block>
    </finder-block-wrapper>
    <!-- Descriptive Text -->
    <finder-block-wrapper *ngSwitchCase="'descriptiveText'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        class="block-element">
        <finder-descriptive-text
            [data]="block"
            [useMediaGallery]="block?.mediaEngine ? true : false"
        ></finder-descriptive-text>
    </finder-block-wrapper>
    <!-- Email Capture -->
    <finder-block-wrapper *ngSwitchCase="'emailCapture'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="[block.fullWidth === false ? 'inner-container' : '', '' + block.style]"
        [class.lg-spacer]="!disableDefaultSpacing"
        class="block-element">
        <finder-email-capture
            [emailData]="block.data"
        ></finder-email-capture>
    </finder-block-wrapper>
    <!-- Multi CTA -->
    <finder-block-wrapper *ngSwitchCase="'multiCta'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        class="block-element">
        <finder-multi-cta
            [data]="block"
        ></finder-multi-cta>
    </finder-block-wrapper>
    <!-- Horizontal Rule -->
    <finder-block-wrapper *ngSwitchCase="'horizontalRule'"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        class="block-element">
        <finder-horizontal-rule
            *ngIf="block.enabled !== false"
            [data]="block"
        ></finder-horizontal-rule>
    </finder-block-wrapper>
    <!-- Avatar List -->
    <finder-block-wrapper *ngSwitchCase="'avatarList'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.avatar-list]="!disableDefaultSpacing"
        class="block-element">
        <finder-avatar-list
            *ngIf="block"
            [title]="block.headerData"
            [avatarList]="block.list"
            [disableAnimation]="block.disableAnimation"
            [listAvatarWidth]="block.listAvatarWidth"
        ></finder-avatar-list>
    </finder-block-wrapper>
    <!-- Lottie -->
    <finder-block-wrapper *ngSwitchCase="'lottie'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.no-padding]="!disableDefaultSpacing"
        class="block-element">
        <finder-campaign-lottie
            [data]="block.lottieData"
        ></finder-campaign-lottie>
    </finder-block-wrapper>
    <!-- Iframe -->
    <finder-block-wrapper *ngSwitchCase="'iframe'"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.no-padding]="!disableDefaultSpacing"
        class="block-element">
        <finder-iframe
            [headerData]="block.headerData"
            [iframeData]="block.iframeData"
        ></finder-iframe>
    </finder-block-wrapper>
    <!-- Availability Calendar -->
    <finder-block-wrapper *ngSwitchCase="'availabilityCalendar'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.no-padding]="!disableDefaultSpacing"
        class="block-element">
        <finder-availability-calendar
            [data]="block"
        ></finder-availability-calendar>
    </finder-block-wrapper>
    <!-- Pricing Grid -->
    <finder-block-wrapper *ngSwitchCase="'pricingGrid'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.no-padding]="!disableDefaultSpacing"
        class="block-element">
        <finder-pricing-grid
            [data]="block"
        ></finder-pricing-grid>
    </finder-block-wrapper>
    <!-- Multi Column Text -->
    <finder-block-wrapper *ngSwitchCase="'multiColumnText'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.no-padding]="!disableDefaultSpacing"
        class="block-element">
        <finder-multi-column-text
            [data]="block"
        ></finder-multi-column-text>
    </finder-block-wrapper>
    <!-- Collapsible Text -->
    <finder-block-wrapper *ngSwitchCase="'collapsibleText'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.no-padding]="!disableDefaultSpacing"
        class="block-element">
        <finder-collapsible-text
            [data]="block"
        ></finder-collapsible-text>
    </finder-block-wrapper>
    <!-- Tutorial -->
    <finder-block-wrapper *ngSwitchCase="'tutorial'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.no-padding]="!disableDefaultSpacing"
        class="block-element">
        <finder-tutorial
            [data]="block"
        ></finder-tutorial>
    </finder-block-wrapper>
    <!-- Live Person Button -->
    <finder-block-wrapper *ngSwitchCase="'livePersonButton'"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        class="block-element">
        <finder-live-person
            [data]="block"
        ></finder-live-person>
    </finder-block-wrapper>
    <!-- Carousel -->
    <finder-block-wrapper *ngSwitchCase="'carousel'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        class="block-element">
        <!-- @SSR: This component does not get along with SSR. Check inside for details-->
        <finder-carousel
            [data]="block"
        ></finder-carousel>
    </finder-block-wrapper>
    <!-- Shared Table -->
    <finder-block-wrapper *ngSwitchCase="'sharedTable'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        [class.no-padding]="!disableDefaultSpacing"
        class="block-element">
        <finder-shared-table
            [data]="block.data"
        ></finder-shared-table>
    </finder-block-wrapper>
    <!-- Package Cards -->
    <finder-block-wrapper *ngSwitchCase="'packageCards'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        class="block-element">
        <finder-sample-packages
            *ngFor="let packageCards of block.packages"
            [packagesData]="packageCards"
        ></finder-sample-packages>
    </finder-block-wrapper>
    <!-- Tab Component -->
    <finder-block-wrapper *ngSwitchCase="'tabComponent'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="['blockId-' + block.data.blockId, '' + block.style]"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        class="block-element">
        <finder-tab
            [data]="block.data"
            [parentId]="block.id"
        ></finder-tab>
    </finder-block-wrapper>
    <!-- Pass Detail Card -->
    <finder-block-wrapper *ngSwitchCase="'passDetailCard'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        class="block-element">
        <finder-pass-detail-card
            [data]="block?.data"
            [headerData]="block?.headerData"
        ></finder-pass-detail-card>
    </finder-block-wrapper>
    <!-- Media Drawer -->
    <finder-block-wrapper *ngSwitchCase="'mediaDrawer'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        [class.inner-container]="!disableDefaultSpacing"
        class="block-element">
        <finder-media-drawer
            [data]="block"
        ></finder-media-drawer>
    </finder-block-wrapper>
    <!-- Parallax Image -->
    <finder-block-wrapper *ngSwitchCase="'parallaxImage'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        class="block-element">
        <finder-parallax-image
            [data]="block"
        ></finder-parallax-image>
    </finder-block-wrapper>
    <!-- Image Drawer -->
    <finder-block-wrapper *ngSwitchCase="'imageDrawer'"
        [blockData]="block"
        [finderScrollTo]="block.id"
        [finderCmsMargin]="block.spacing"
        (finderInViewport)="analyticsFireTrackSeen(block.analyticsProgressionLinkId)"
        [ngClass]="block.style"
        [class.lg-spacer]="!disableDefaultSpacing"
        class="block-element">
        <finder-image-drawer
            [data]="block.data"
        ></finder-image-drawer>
    </finder-block-wrapper>

    <!-- Bottom HR - Make sure this is always at the bottom! -->
    <finder-horizontal-rule *ngIf="block.hrData?.bottomLine"
        [finderCmsMargin]="block.spacing"
        [data]="block.hrData"
        [position]="'bottom'">
    </finder-horizontal-rule>
    <!-- DO NOT ADD COMPONENTS HERE - SEE ABOVE COMMENT -->
</div>
